import React, { useState, useEffect } from "react";
import { Modal, Select, Input, message, Alert } from "antd";
import { businessPartnerApi } from "../../../../api/contractManagementApi";
import { settlementService } from "../../../../api/enhancedApi";

const { TextArea } = Input;

/**
 * 批量指定合作方弹窗
 * 用于将选中的 IDS 记录关联到指定的客户合作方（发布前准备）
 */
const BatchAssignPartnerModal = ({ open, onClose, selectedIds = [], onSuccess }) => {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [selectedPartnerId, setSelectedPartnerId] = useState(null);
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        if (open) {
            loadPartners();
            setSelectedPartnerId(null);
            setRemarks("");
        }
    }, [open]);

    const loadPartners = async () => {
        setLoading(true);
        try {
            // 注意：/customers 端点直接返回数组，非分页格式
            const response = await businessPartnerApi.getCustomers({
                is_active: true,
            });
            const list = Array.isArray(response.data) ? response.data : (response.data?.items || []);
            setPartners(
                list.map((p) => ({
                    value: p.id,
                    label: p.code ? `${p.name} (${p.code})` : p.name,
                })),
            );
        } catch (error) {
            console.error("加载合作方列表失败:", error);
            message.error("加载合作方列表失败");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!selectedPartnerId) {
            message.warning("请选择合作方");
            return;
        }
        if (selectedIds.length === 0) {
            message.warning("未选择任何记录");
            return;
        }

        setSubmitting(true);
        try {
            await settlementService.portalPublication.batchCreate({
                ids_ids: selectedIds,
                customer_partner_id: selectedPartnerId,
                remarks: remarks.trim() || undefined,
            });
            message.success(`成功为 ${selectedIds.length} 条记录指定合作方`);
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error("指定合作方失败:", error);
            message.error("指定合作方失败: " + (error.response?.data?.detail || error.message));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="指定合作方"
            open={open}
            onCancel={onClose}
            onOk={handleSubmit}
            confirmLoading={submitting}
            okText="确认"
            cancelText="取消"
            width={480}
        >
            <Alert
                message={`已选择 ${selectedIds.length} 条记录`}
                description="选择合作方后，系统将为这些记录创建门户发布记录（状态：待发布）。重复的组合会被自动跳过。"
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />

            <div style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 4, fontWeight: 500 }}>合作方 <span style={{ color: "#ff4d4f" }}>*</span></div>
                <Select
                    placeholder="请搜索或选择合作方"
                    showSearch
                    loading={loading}
                    value={selectedPartnerId}
                    onChange={setSelectedPartnerId}
                    options={partners}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    style={{ width: "100%" }}
                />
            </div>

            <div>
                <div style={{ marginBottom: 4, fontWeight: 500 }}>备注（可选）</div>
                <TextArea
                    placeholder="添加备注信息..."
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    maxLength={500}
                />
            </div>
        </Modal>
    );
};

export default BatchAssignPartnerModal;
